import React from "react";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  Navigate,
} from "react-router-dom";

import ConstList from "../utils/ConstList";
import { maintenanceState } from "../stores/MaintenanceAtom";
import AdminHome from "./Home_By_Admin";
import ReleaceNote from "./ReleaceNote";
import PrivateRouter from "../component/PrivateRouter";
import Login from "./Login";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useRecoilState } from "recoil";
import { LoginUserAtom } from "../stores/LoginUserAtom";
import Loading from "../component/Loading";
import Header from "./Header";
import Setting from "./Setting";
import MyPage from "./MyPage";

// ページコンポーネント
import MasterSDMS from "./SDMS_prosCustomer";
import ExistingCustomers from "./SDMS_exiCustomers";
import StoppedCustomers from "./SDMS_stoppedCustomers";
import Setting_User from "../component/Setting_User";
import MaintenanceGate from "../component/MaintenanceGate";

const Routers = () => {
  const { isAuthenticated, isLoading, user, getAccessTokenSilently } =
    useAuth0();
  console.log(user);
  //APIの際のURL
  const getTokenUrl =
    ConstList.getAuthenticationApiUrl() + "getExternalToken.php";

  // ログインで使用
  const [loginUserData, setLoginUserData] = useRecoilState(LoginUserAtom);

  //useEffectを初回に走らせないようにするためのRef
  const notFirstRef = useRef(false);

  const [maintenance, setMaintenance] = useRecoilState(maintenanceState);
  const [routerLoading, setRouterLoading] = useState(true); // ログインユーザー情報のローディング

  console.log(loginUserData);

  // ユーザーとログインユーザーの情報取得
  useEffect(() => {
    if (!notFirstRef.current) {
      notFirstRef.current = true;
    } else {
      const fetchUserData = async () => {
        const tmpAccessToken = await getAccessTokenSilently({
          audience: `https://${ConstList.DOMAIN}/api/v2/`,
        });
        if (user != undefined) {
          const userData = {
            userId: user.sub ?? "",
            email: user.email ?? "",
            userName: user.name ?? "",
            accessToken: tmpAccessToken,
            algorithm: ConstList.ALGORITHM,
          };

          setLoginUserData(userData);
        }

        setRouterLoading(false);
      };
      fetchUserData();
    }
  }, [user != undefined]);

  return (
    <>
<Router basename={ConstList.SYS_TOPDOMAIN}>
  <Header />

  {isAuthenticated && !routerLoading ? (
    <MaintenanceGate>
      <Routes>
        <Route
          path="/home"
          element={
            <PrivateRouter>
              <AdminHome />
            </PrivateRouter>
          }
        />

        <Route
          path="/setting"
          element={
            <PrivateRouter>
              <Setting />
            </PrivateRouter>
          }
        />

        <Route
          path="/my_page"
          element={
            <PrivateRouter>
              <MyPage />
            </PrivateRouter>
          }
        />

        <Route
          path="/ReleaceNote"
          element={
            <PrivateRouter>
              <ReleaceNote />
            </PrivateRouter>
          }
        />

        <Route
          path="/Prospective_customers"
          element={
            <PrivateRouter>
              <MasterSDMS />
            </PrivateRouter>
          }
        />

        <Route
          path="/ExistingCustomers"
          element={
            <PrivateRouter>
              <ExistingCustomers />
            </PrivateRouter>
          }
        />

        <Route
          path="/SDMS_stoppedCustomers"
          element={
            <PrivateRouter>
              <StoppedCustomers />
            </PrivateRouter>
          }
        />

        <Route
          path="/setting/users"
          element={
            <PrivateRouter>
              <Setting_User />
            </PrivateRouter>
          }
        />
      </Routes>
    </MaintenanceGate>
  ) : (
    <Routes>
      {isLoading || routerLoading ? (
        <>
          <Route path="/" element={<Loading />} />
          <Route path="*" element={<Loading />} />
        </>
      ) : (
        <>
          <Route path="/" element={<Login />} />
          <Route path="*" element={<Navigate replace to="/" />} />
        </>
      )}
    </Routes>
  )}
</Router>
    </>
  );
};
export default Routers;
